/**
 *
 * @param feature
 */
export function getClassFeatureId(feature) {
    return feature.classFeatureId;
}
/**
 *
 * @param feature
 */
export function getAffectedClassFeatureId(feature) {
    return feature.affectedClassFeatureId;
}
/**
 *
 * @param feature
 */
export function getDefinitionKey(feature) {
    return feature.classFeatureDefinitionKey;
}
/**
 *
 * @param feature
 */
export function getAffectedClassFeatureDefinitionKey(feature) {
    return feature.affectedClassFeatureDefinitionKey;
}
/**
 *
 * @param feature
 */
export function getClassFeature(feature) {
    return feature.classFeature;
}
/**
 *
 * @param feature
 */
export function getAccessType(feature) {
    return feature.accessType;
}
